import React from 'react';
import {
  FDStack, FDBox, FDPaper, FDBodyText, FDIcon, FDHeadlineText, FDVideo,
} from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';

export const IndustryExperts = () => {
  const { resource } = useMetaLayoutContext();
  const isMobile = useMobileLayout();
  const collection = resource.attr('influencerExpertTestimonialCollection');

  if (!collection) return null;

  const sections = resource.attr('influencerExpertTestimonialCollection').resources().list();

  return (
    <FDBox paddingY={isMobile ? 2 : 3}>
      <FDStack spacing={4} overflow={'auto'} width={'100%'} height={'100%'} paddingX={isMobile ? 2 : 4} paddingY={1}>
        {sections.map((section) => (
          <FDPaper appearance={'flat'} width={isMobile ? '90%' : '675px'} flexShrink={0}>
            <FDStack direction={isMobile ? 'column' : 'row'} spacing={1}>
              {section.withRelationship(fr.relationships.video.name, (rel) => (
                <FDVideo
                  captionsSrc={'captions'}
                  src={rel.link('related').url()}
                  maxWidth={isMobile ? '100%' : '40%'}
                />), () => null)}
              <FDStack direction={'column'} spacing={4} flex={1} paddingX={isMobile ? 2 : 4} paddingY={isMobile ? 3 : 6} justifyContent={'space-between'}>
                <FDStack direction={'column'} spacing={2}>
                  <FDStack direction={'row'} spacing={4} alignItems={'center'}>
                    <FDHeadlineText value={section.attr('title')} color={'textSecondary'} />
                    <FDIcon icon={'identityVerified'} color={'textSecondary'} size={'sm'} />
                  </FDStack>
                  <FDBodyText value={section.attr('description')} />
                </FDStack>
                <FDHeadlineText value={section.attr('callout')} size={'sm'} />
              </FDStack>
            </FDStack>
          </FDPaper>
        ))}
      </FDStack>
    </FDBox>
  );
};
